import { useMemo } from 'react'

import { routes, useLocation } from '@cedarjs/router'

import Navigation, { NavElement } from 'src/components/Sidebar/Navigation/Navigation'
import { useMyUser } from 'src/layouts/AppStateContextLayout/utils'
import { formatName } from 'src/utils'

const UserProfileNavItem = () => {
  const me = useMyUser()
  const firstName = me?.firstName
  const lastName = me?.lastName
  const { pathname } = useLocation()

  const isActive = pathname === routes.userProfile()

  const title =
    firstName || lastName ? formatName(firstName, lastName) : me?.emailAddress || 'User Profile'

  const navElements: NavElement[] = useMemo(
    () => [
      {
        icon: 'FaUser',
        internalRoute: routes.userProfile(),
        isActive,
        title,
      },
    ],
    [isActive, title]
  )

  return <Navigation elements={navElements} />
}

export default React.memo(UserProfileNavItem)
